import { Component, OnInit, Inject, ViewChild, AfterViewInit, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatInput, MatSelect } from '@angular/material';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { AddDocumentTypeComponent } from '../add-document-type-list/add-document-type/add-document-type.component';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Message } from 'src/app/core/class/message';
import { NgForm, FormControl } from '@angular/forms';
import { Subscription, ReplaySubject, Subject } from 'rxjs';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { CommonService } from '../../../../../../core/services/common.service';
import { takeUntil } from 'rxjs/operators';
import Utils from 'src/app/core/services/app-utils';
import { ApiService } from 'src/app/core/services/api.service';

@Component({
  selector: 'app-update-document-type',
  templateUrl: './update-document-type.component.html'
})
export class UpdateDocumentTypeComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    private apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private el: ElementRef,
    private documentTypeService: DocumentTypeService,
    public dialogRef: MatDialogRef<AddDocumentTypeComponent>,
    private dialog: MatDialog,
    public commonService: CommonService,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    private router: Router) {
    // Get data from DocumentTypeComponent
    this.id = data.id;
    dialogRef.backdropClick().subscribe(_ => {
      this.cancel();
    });
  }

  documentTypeEnterprise = {
    name: '',
    code: '',
    parentId: null,
    serviceType: null,
    description: ''
  };

  id: any;
  parentId: any;

  serviceTypes: comboBox[] = [];
  parentIds: comboBox[] = [];

  serviceTypesFilterCtrl: FormControl = new FormControl();
  parentIdsFilterCtrl: FormControl = new FormControl();

  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredParentIds: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private _onDestroy = new Subject<void>();

  checkFocus = true;
  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  // Whether the form change or not
  isFormChanging = false;
  @ViewChild('focusInput', { static: false }) focusInput: MatInput;
  @ViewChild('serviceTypesSelect', { static: false }) serviceTypesSelect: MatSelect;
  @ViewChild('parentSelect', { static: false }) parentSelect: MatSelect;
  checkEscKey = false;
  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (!this.checkEscKey) {
      this.cancel();
    }
  }

  ngOnInit() {
    this.apiService.addUrlToHandlingErrorRestApisPut('/enterprise/document-type');
    this.serviceTypesFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes); });
    this.parentIdsFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.commonService.filterCertificateType(this.parentIds, this.parentIdsFilterCtrl, this.filteredParentIds); });

    this.getDocumentTypeById(this.id);
    this.notificationService.subscribeErrorService();
  }

  /**
   * On After Init
   */
  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.focused = true);
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty || this.ngForm.touched) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.apiService.removeUrlToHandlingErrorRestApis();
    this.formChangesSubscription.unsubscribe();
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Get document type by id
   */
  getDocumentTypeById(id: any) {
    this.documentTypeService.findById(id).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      this.documentTypeEnterprise = {
        ...rs.data
      };
      // Set null for parentId
      if (this.documentTypeEnterprise.parentId !== undefined) {
        this.parentId = this.documentTypeEnterprise.parentId;
        this.getParentIds(this.documentTypeEnterprise.code);
      } else {
        this.parentId = null;
        this.getServiceTypes(this.id);
      }
    });
  }

  /**
   * Get ServiceType list to show for combobox
   */
  getServiceTypes(id: any) {
    this.documentTypeService.getServiceTypes(id).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      const result = rs.data;
      this.serviceTypes = result;
      this.filteredServiceTypes.next(this.serviceTypes.slice());
    });
  }

  /**
   * Get ParentId list to show for combobox
   */
  getParentIds(code: any) {
    this.documentTypeService.getParentIds(code).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      const result = rs.data;
      this.parentIds = result;
      this.filteredParentIds.next(this.parentIds.slice());
    });
  }

  private onUpdateEnterpriseError(rs: any) {
    if (!rs.success) {
      if (rs.code === '0x00125') {
        this.certificateNoExistingHanlder(rs);
      } else {
        this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
      }
    }
  }
  private certificateNoExistingHanlder(rs: any): void {
    this.ngForm.form.controls.name.setErrors({ incorrect: true, duplicate: true });
    document.getElementById('name').focus();
  }

  /**
   * Update document type
   */
  updateDocumentType() {
      this.documentTypeService.updateDocumentType(this.documentTypeEnterprise, () => { }, () =>
      this.onUpdateEnterpriseError.bind(this))
      .subscribe(rs => {
        if (rs && rs.success) {
          this.toastr.success(this.message.getMessage('messages.update_success'));
          this.router.navigate(['/home-enterprise/document-type']);
          this.dialogRef.close();
        } else if (rs && !rs.success) {
          if (rs.code === '0x00125') {
            this.certificateNoExistingHanlder(rs);
          } else {
            this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
          }
        }
      });
  }

  /**
   * Close pop-up
   */
  cancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

}
